import { JobSeekerJobPositionAssignmentNode, useGetJobPositionAssignmentsQuery } from "@graphql/generated";
import { useJobSuggestionStore } from "@modules/JobSuggestion/stores/useJobSuggestionStore";
import { useEffect } from "react";

export const useJobSuggestion = (id: string) => {
  const { jobSuggestion, isLoading, setJobSuggestion, setIsLoading } = useJobSuggestionStore();

  const {
    data,
    loading,
    refetch: refetchJobSuggestion,
  } = useGetJobPositionAssignmentsQuery({
    variables: {
      id,
    },
  });

  useEffect(() => {
    setJobSuggestion(data?.me?.jobPositionAssignments?.edges[0]?.node as JobSeekerJobPositionAssignmentNode);
    setIsLoading(loading);
  }, [data, loading, setIsLoading, setJobSuggestion]);

  return { jobSuggestion, isLoading, refetchJobSuggestion };
};
